/** URL-friendly slug from a label (e.g. "Notices & News" -> "notices-news"). */
export const slugify = (value) =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
